import { render } from "./SingletrackStudy.vue?vue&type=template&id=3c8b829e"
import script from "./SingletrackStudy.vue?vue&type=script&lang=js"
export * from "./SingletrackStudy.vue?vue&type=script&lang=js"

import "./SingletrackStudy.vue?vue&type=style&index=0&id=3c8b829e&lang=css"
script.render = render

export default script